import axios from 'axios'
import { logout } from './logout';

export const baseURL = `${process.env.REACT_APP_BASE_URL_SERVER}/api/v1/inventory`;
export const baseUrlImage = `${process.env.REACT_APP_BASE_URL_SERVER}`;

const apiClient = axios.create({
    baseURL: baseURL,
    headers: {
        'Content-Type': 'application/json',
    }
});

// Access token to each request
apiClient.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("accessToken");
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config
    },
    (error) => Promise.reject(error)
)

// handle auto refresh
apiClient.interceptors.response.use(
    
    (response) => (response),
    async (error) => {
        const originalRequest = error.config;

        // if 401 unauthorized
        if (error.response?.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;
            const refreshToken = localStorage.getItem("refreshToken");
            if (!refreshToken) {
                logout();
                return Promise.reject(error)
            }

            try {
                // Call refresh endpoint
                const data = await axios.post(`${process.env.REACT_APP_BASE_URL_SERVER}/api/v1/inventory/auth/refresh`,
                    { refresh:refreshToken }
                );

                // save new token
                localStorage.setItem("accessToken", data.data.access);
                if (data.data.refresh) {
                    localStorage.setItem("refreshToken", data.data.refresh)
                }

                // update header and retry riginal request
                apiClient.defaults.headers.common["Authorization"] = `Bearer ${data.data.access}`;
                originalRequest.headers.Authorization = `Bearer ${data.data.access}`;

                return apiClient(originalRequest);
            } catch (refreshError) {
                console.error("Refresh token expired or invalid. Logging out...");
                logout();
                return Promise.reject(refreshError);
            }
        }
        return Promise.reject(error);
    }
)

export default apiClient;